import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './app'
import ReactGA from 'react-ga4'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
ReactGA.initialize('G-3RH276ZL96')
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

serviceWorkerRegistration.register()

const SendAnalytics = () => {
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname
  })
}
reportWebVitals(SendAnalytics)
